// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logotype":"Header_logotype__wzkZC"};